import {
  Avatar,
  AvatarGroup,
  Box,
  Dialog,
  Slide,
  Stack,
  Typography,
  Button
} from "@mui/material";
import React, {useState } from "react";
import {  useAppSelector } from "../../assets/hooks";
// import CustomTabs from "../../genericComponents/tabs";
import Advisors from "./advisors";
import Community from "./community";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TransitionProps } from "@mui/material/transitions";
import Images from "../../assets";
import AddIcon from "@mui/icons-material/Add";

import NewChatContainer from "./newChatComponent";
// import { setPopup } from "../../store/slices/popupSlice";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Chat = () => {
  const userAuthStatus = useAppSelector((state) => state.userAuthStatus);
  const [open, setOpen] = useState(false);
  const [newChatOpen, setNewOpen] = useState(false);

  // const dispatch = useAppDispatch();
  const GuestUser = () => {
    return (
      <div
        style={{
          background: "#EDF2F6",
          padding: "1.5rem",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "start",
            mb: 2,
          }}
        >
          <AvatarGroup max={4}>
            <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
            <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
            <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
            <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" />
            <Avatar alt="Trevor Henderson" src="/static/images/avatar/5.jpg" />
          </AvatarGroup>
          <Typography color="#3B3F76" fontWeight="600" gutterBottom>
            Say goodbye to all your doubts !
          </Typography>
          <Typography color="#FEB853" gutterBottom>
            As you say hello to our profound advisors !{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            background: "#fff",
            p: 2,
            borderRadius: "10px",
            position: "absolute",
            left: "20px",
            right: "20px",
            boxShadow: "2",
          }}
        >
          <Typography gutterBottom>
            Login to start chat with{" "}
            <span style={{ color: "#FEB853" }}>Students </span>
            and <span style={{ color: "#FEB853" }}>Advisors</span>.
          </Typography>
          <Button
            // width="100%"
            // onClick={() => {
            //   setOpen(false);
            //   dispatch(
            //     setPopup({
            //       show: true,
            //       data: {
            //         container: {
            //           name: "login",
            //           dimensions: {
            //             width: "500px",
            //           },
            //         },
            //         type: "custom",
            //       },
            //     })
            //   );
            // }}
          >
            Login
          </Button>
        </Box>
      </div>
    );
  };

  const ChatsListContainer = () => {
    const [activeTab, setActiveTab] = useState<"advisors" | "community">("advisors");
    return (
      <Stack spacing={1} sx={{height: "480px", p: 2 ,justifyContent:"center",alignItems:"center"}}>
        <Box
          sx={{ display: "flex", justifyContent: "space-between", alignItems:"center",width:"80%",}}
        >
          <Button
            onClick={() => setActiveTab("advisors")}
            sx={{
              borderBottom: activeTab === "advisors" ? "2px solid #3B3F76" : 0,
              color:activeTab === "advisors" ? "#3B3F76" : "#3B3F7680",
              borderRadius: 0,
              textTransform: "none",
              fontSize: "1rem",
            }}
          >
            Advisors
          </Button>
          <Button
            onClick={() => setActiveTab("community")}
            sx={{
              borderBottom: activeTab === "community" ? "2px solid #3B3F76" : 0,
              color:activeTab === "community" ? "#3B3F76" : "#3B3F7680",
              textTransform: "none",
              borderRadius: 0,
              fontSize: "1rem",
            }}
          >
            Community
          </Button>
          </Box>
          {activeTab === "advisors" ? 
          <Advisors/> : 
          <Community/>
        }
        <div style={{ position: "absolute", bottom: "12px", right: "12px" }}>
          <div
          onClick={()=>setNewOpen(true)}
          style={{
            background:"#3B3F76",
            color:"#fff",
            height:"1rem",
            width:"1rem",
            borderRadius:"50%",padding:"0.2rem",
            cursor:"pointer"
           
          }}
          >
            <AddIcon  sx={{fontSize:"1rem"}}/>
          </div>
        </div>
      </Stack>
    );
  };

  return (
    <div>
      <div>
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: "1000",
          }}
        >
          <img
            style={{
              width: "3rem",
              height: "3rem",
              cursor: "pointer",
            }}
            src={Images.chaticon}
            alt="chat icon"
            onClick={() => setOpen(true)}
          />
        </div>
        <Dialog
          open={open}
          sx={{
            right: "0",
            left: { md: "45%", xs: "0", lg: "68%" },
            top: { md: "1%", xs: "0", lg: "5%" },
          }}
          PaperProps={{
            style: {
              borderRadius: "1rem",
              padding: "1rem",
              width: "410px",
              height: "550px",
            },
          }}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setOpen(false)}
          aria-describedby="alert-dialog-slide-description"
        >
          <Box
            sx={
              {
                // justifyContent:"center"
              }
            }
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <KeyboardArrowDownIcon
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  top: 0,
                  color: "#0F0F0F",
                  fontSize: "2rem",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            </Box>
            {userAuthStatus.data?.isAuthorized ? (
              <ChatsListContainer />
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  height: "50vh",
                }}
              >
                <GuestUser />
              </div>
            )}
          </Box>
        </Dialog>
        {newChatOpen ? (
        <NewChatContainer
          open={newChatOpen}
          setOpen={setNewOpen}
        />
      ) : (
        ""
      )}
      </div>
    </div>
  );
};

export default Chat;
